import React from 'react';

import {
  Box,
  Button,
  HeadingText,
  Modal,
  VisuallyHidden,
} from '@leagueplatform/genesis-core';
import { ChatContent } from '@leagueplatform/chat';
import { useIntl } from '@leagueplatform/locales';
import { endDemoChat, useDemoMode } from 'common/demo-mode';

// A demo needs the opposite of the SDK's corner panel: full-bleed, no minimizing
// out of it, its own title. `ChatContent` is the conversation without that
// chrome, so the chrome is ours.
const CHAT_HEADING_ID = 'demo-chat-heading';

export const DemoChat = () => {
  const { formatMessage } = useIntl();
  const { isFullscreenChat, chat } = useDemoMode();

  return (
    <Modal.Root open={isFullscreenChat}>
      <Modal.Content
        layout="fullscreen"
        padding="$none"
        showCloseButton={false}
        aria-labelledby={CHAT_HEADING_ID}
        // `End chat` is the only way out: otherwise a running demo could be left
        // hidden with no way back to it.
        onEscapeKeyDown={(event) => event.preventDefault()}
        onInteractOutside={(event) => event.preventDefault()}
        css={{
          '.GDS-modal': {
            top: 0,
            bottom: 0,
            insetInlineStart: 0,
            insetInlineEnd: 0,
            width: '100vw',
            height: '100%',
            maxHeight: '100%',
            borderRadius: 0,
          },
          // The conversation needs a flex column with a definite height; the
          // content area is a plain block by default.
          '.GDS-modal-content': {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 0',
            minHeight: 0,
          },
        }}
      >
        <Modal.Title>
          <VisuallyHidden>
            {formatMessage({ id: 'STR_DEMO_CHAT_TITLE' })}
          </VisuallyHidden>
        </Modal.Title>
        <Box
          css={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexShrink: 0,
            minHeight: '58px',
            paddingInline: '$half',
            backgroundColor: '$primaryBackgroundDefault',
          }}
        >
          <HeadingText
            id={CHAT_HEADING_ID}
            level="2"
            size="sm"
            css={{
              position: 'absolute',
              insetInlineStart: '50%',
              transform: 'translateX(-50%)',
              color: '$onSurfaceTextReversed',
            }}
          >
            {formatMessage({ id: 'STR_DEMO_CHAT_TITLE' })}
          </HeadingText>
          <Button
            priority="tertiary"
            quiet
            onClick={endDemoChat}
            css={{ color: '$onSurfaceTextReversed' }}
          >
            {formatMessage({ id: 'STR_DEMO_CHAT_END' })}
          </Button>
        </Box>
        <ChatContent chatInstance={chat} />
      </Modal.Content>
    </Modal.Root>
  );
};
